import { createApp } from 'vue'
import FLinkCard from '~/js/components/linkCard'
import { LinkItem } from '~/js/models/linkItem'
import { favouriteCoordinateHandles } from '~/js/templates/index/helpers'

const CLASS_NAME = 'js-linkList'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const blogHandle = element.dataset.blogHandle
    try {
      const linkItems = JSON.parse(element.dataset.linkItems).map(
        (linkItem) => {
          const url = `/blogs/${blogHandle}/${linkItem.handle}`
          const isFavourite = favouriteCoordinateHandles.includes(
            linkItem.handle
          )
          return new LinkItem(linkItem, url, isFavourite)
        }
      )
      createApp({
        name: 'SnippetsLinkList',
        data() {
          return {
            linkItems,
          }
        },
        components: {
          FLinkCard,
        },
      }).mount(element)
    } catch (error) {
      console.error(error)
    }
  })
})
